// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-ru-thanks-js": () => import("./../../../src/pages/ru/thanks.js" /* webpackChunkName: "component---src-pages-ru-thanks-js" */),
  "component---src-pages-thanks-js": () => import("./../../../src/pages/thanks.js" /* webpackChunkName: "component---src-pages-thanks-js" */),
  "component---src-templates-prismic-page-js": () => import("./../../../src/templates/PrismicPage.js" /* webpackChunkName: "component---src-templates-prismic-page-js" */)
}

